let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});
function getCookie(name) {
	let matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}
function setCookie(name, value, options = {}) {

	if (options.expires instanceof Date) {
		options.expires = options.expires.toUTCString();
	}
	let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

	for (let optionKey in options) {
		updatedCookie += "; " + optionKey;
		let optionValue = options[optionKey];
		if (optionValue !== true) {
			updatedCookie += "=" + optionValue;
		}
	}

	document.cookie = updatedCookie;
}
function validateEmail(email){
	let email_string = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if(email.match(email_string)){
		return true;
	}else {
		return false;
	}

}
function validatePhone(phone){
	let letters =/[a-zA-Z\/\\\*\%\$\|\#\@\'\"\:\;\&\?\.\,\<\>]/g;
	if(phone.match(letters)){
		return false;
	}
	else{
		return true ;
	}
}
// faq content nav
let faqContent = document.querySelectorAll(".faq-content");
if (faqContent.length > 0) {
	const navList = document.querySelector('.text-nav-list');
	const navLinks = document.querySelectorAll(".text-content h3");
	let navListArrey = [];
	let isScrollingDisabled = false;
	navLinks.forEach((heading, index) => {
		const id = "section-" + (index + 1);
		heading.setAttribute("id", id);
		const listItem = document.createElement("li");
		const navItem = document.createElement("button");
		navItem.setAttribute("data-id", id);
		navItem.setAttribute("class", 'text-nav-item');
		const navItemMore = document.createElement("span");
		navItem.textContent = heading.textContent;
		navItem.appendChild(navItemMore);
		listItem.appendChild(navItem);
		navList.appendChild(listItem);
		navItem.addEventListener('click', function (e) {
			isScrollingDisabled = true;
			window.scrollTo({
				top: navLinks[index].getBoundingClientRect().top + window.scrollY - document.querySelector('.header-group').offsetHeight,
				behavior: 'smooth'
			});
			navListArrey.forEach(item => item.classList.remove('active'));
			navItem.classList.add('active');
			setTimeout(() => {
				isScrollingDisabled = false;
			}, 1000);
		});
	});
	navListArrey = navList.querySelectorAll('.text-nav-item');
	navListArrey[0].classList.add('active');
	window.addEventListener('scroll', () => {
		if (isScrollingDisabled) return;
		let current = "";
		navLinks.forEach((heading, index) => {
			const sectionTop = heading.offsetTop - document.querySelector('.header-group')?.offsetHeight + 65;
			if (window.scrollY >= sectionTop) {
				current = heading.getAttribute("id");
			}
		});
		navListArrey.forEach(navItem => {
			navItem.classList.remove('active');
			if (navItem.getAttribute("data-id") === current) {
				navItem.classList.add('active');
			}
		});
	});
}
// nav-content

let jsNavContent = document.querySelectorAll(".js-nav-content h2");
if (jsNavContent.length > 0) {
	const navList = document.querySelector('.text-nav-item.active');
	const navLinks = document.querySelectorAll(".text-content h2");
	let navListArrey = [];
	let isScrollingDisabled = false;
	const list = document.createElement("ul");
	navLinks.forEach((heading, index) => {
		const id = "section-" + (index + 1);
		heading.setAttribute("id", id);
		const listItem = document.createElement("li");
		const navItem = document.createElement("button");
		navItem.setAttribute("data-id", id);
		navItem.setAttribute("class", 'text-nav-item-sub');
		const navItemMore = document.createElement("span");
		navItem.textContent = heading.textContent;
		navItem.appendChild(navItemMore);
		listItem.appendChild(navItem);
		list.appendChild(listItem);
		navList.appendChild(list);
		navItem.addEventListener('click', function (e) {
			isScrollingDisabled = true;
			window.scrollTo({
				top: navLinks[index].getBoundingClientRect().top + window.scrollY - document.querySelector('.header-group').offsetHeight,
				behavior: 'smooth'
			});
			navListArrey.forEach(item => item.classList.remove('active'));
			navItem.classList.add('active');
			setTimeout(() => {
				isScrollingDisabled = false;
			}, 1000);
		});
	});
	navListArrey = navList.querySelectorAll('.text-nav-item-sub');
	navListArrey[0].classList.add('active');
}
function addressesCount(){
	if(document.querySelector('.js-address-section')){
		let addressesCount = parseInt(document.querySelector('.js-address-section').dataset.addressesCount),
			addressesAccount = parseInt(document.querySelector('.js-address-section').dataset.addressesAccount);
		let previousAddressesCount = localStorage.getItem('addressesCount');
		let previousAddressesAccount = localStorage.getItem('addressesAccount');
		if(previousAddressesAccount){
			if(previousAddressesAccount != addressesAccount){
				localStorage.setItem('addressesCount', `${addressesCount}`);
				previousAddressesCount = addressesCount;
				localStorage.setItem('addressesAccount', `${addressesAccount}`);
			}else{
				localStorage.setItem('addressesAccount', `${addressesAccount}`);
			}
		}else{
			localStorage.setItem('addressesAccount', `${addressesAccount}`);
		}
		if(previousAddressesCount){
			if(parseInt(previousAddressesCount) > addressesCount){
				localStorage.setItem('addressesCount', `${addressesCount}`);
				if(document.querySelector('.js-addresses-notification')){
					document.querySelector('.js-addresses-notification').classList.add('show')
					setTimeout(function (){
						document.querySelector('.js-addresses-notification').classList.remove('show')
					},10000)
				}
			}else{
				localStorage.setItem('addressesCount', `${addressesCount}`);
			}
		}else{
			localStorage.setItem('addressesCount', `${addressesCount}`);
		}

	}
}
addressesCount();
//date-counter

let counterEl = document.querySelector('.vault-coutner');
const formatNumber = number => {
	return number < 10 ? `0${number}` : `${number}`;
};
if (counterEl) {
	const counterElValue = counterEl.getAttribute('data-counter');
	const countdownDate = new Date(counterElValue).getTime();
	const updateCountdown = () => {
		const now = new Date().getTime();
		const distance = countdownDate - now;
		const days = Math.floor(distance / (1000 * 60 * 60 * 24));
		const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
		const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
		const seconds = Math.floor(distance % (1000 * 60) / 1000);
		if(document.getElementById("days")){
			document.getElementById("days").textContent = formatNumber(days);
		}
		if(document.getElementById("hours")){
			document.getElementById("hours").textContent = formatNumber(hours);
		}
		if(document.getElementById("minutes")){
			document.getElementById("minutes").textContent = formatNumber(minutes);
		}

		if(document.getElementById("seconds")){
			document.getElementById("seconds").textContent = formatNumber(seconds);
		}
		if (distance < 0) {
			clearInterval(interval);
			counterEl.classList.add('hide');
			if(counterEl.closest('.vault-container').querySelector('.vault-intro__title')){
				if(counterEl.closest('.vault-container').querySelector('.vault-intro__title').dataset.successTitle){
					counterEl.closest('.vault-container').querySelector('.vault-intro__title').innerHTML = counterEl.closest('.vault-container').querySelector('.vault-intro__title').dataset.successTitle;
					counterEl.closest('.vault-container').querySelector('.vault-intro__title').classList.add('vault-intro__title-big')
				}
			}
		}
		if (!counterElValue) {
			clearInterval(interval);
			counterEl.classList.add('hide');
			if(counterEl.closest('.vault-container').querySelector('.vault-intro__title')){
				if(counterEl.closest('.vault-container').querySelector('.vault-intro__title').dataset.successTitle){
					counterEl.closest('.vault-container').querySelector('.vault-intro__title').innerHTML = counterEl.closest('.vault-container').querySelector('.vault-intro__title').dataset.successTitle;
					counterEl.closest('.vault-container').querySelector('.vault-intro__title').classList.add('vault-intro__title-big')
				}
			}
		}
	};
	const interval = setInterval(updateCountdown, 1000);
	updateCountdown();
}
const nav = document.querySelector('.vip-nav-list-wrapper');
if (nav) {
	const activeElement = nav.querySelector('.active');
	const offsetLeft = activeElement.offsetLeft;
	nav.scrollLeft = offsetLeft;
}
const closeNotification = document.querySelector('.js-close-notification');
if (closeNotification) {
	closeNotification.addEventListener('click', function () {
		closeNotification.closest('.adresses-notification').classList.remove('show');
	});
}

// oreder scroll

const element1 = document.querySelector('.vip-order-table-header .vip-order-table-scroll-columns');
const element2 = document.querySelector('.vip-order-table-body .vip-order-table-scroll-columns');
element1?.addEventListener('scroll', () => {
	element2.scrollLeft = element1.scrollLeft;
});
element2?.addEventListener('scroll', () => {
	element1.scrollLeft = element2.scrollLeft;
});

let vipPageLink = document.querySelectorAll(".js-vip-page-link");
if(vipPageLink){
	vipPageLink.forEach(function (link){
		link.addEventListener('click',function (e){
			e.preventDefault();
			if(this.closest('.popup.wishlist')){
				this.closest('.popup.wishlist').style.display = 'none'
			}
			animateVipPreloaderDown()
			setTimeout(function (){
				window.location.href = link.getAttribute('href')
				window.history.pushState({ prevUrl: window.location.href }, null)
				localStorage.setItem("ShihikoEnableReverseAnimation", "true")
			},1400)
		})
	})
}
let productZoomContainer = document.querySelectorAll('.js-product-gallery-zoom .carousel-item');
let previousX = 0;
let previousY = 0;
if (productZoomContainer) {
	productZoomContainer.forEach(function (block) {
		block.addEventListener('click', function (event) {
			if (this.classList.contains('zoomed')) {
				block.classList.remove('zoomed');
				block.querySelector('img').removeAttribute('style');
                if(block.closest('.product-gallery-carousel').classList.contains('swiper-no-swiping')){
                  block.closest('.product-gallery-carousel').classList.remove('swiper-no-swiping');
                }
			} else {
				setTimeout(function () {
					starterPosition(event, block);
				}, 100);
				setTimeout(function () {
					block.classList.add('zoomed');
				}, 600);
              setTimeout(function (){
    				block.closest('.product-gallery-carousel').classList.add('swiper-no-swiping');
              },500)
			}
			

		});
		if (isTouchDevice()) {
			block.addEventListener('touchstart', function (event) {
				previousX = event.touches[0].clientX;
				previousY = event.touches[0].clientY;
			});
			block.addEventListener('touchmove', function (event) {
				toucheMove(event, block);
			});
		} else {
			block.addEventListener('mousemove', function (event) {
				mouseMove(event, block);
			});
			block.addEventListener('mouseleave', function (event) {
				block.classList.remove('zoomed');
				block.querySelector('img').removeAttribute('style');
				block.closest('.product-gallery-carousel').classList.remove('swiper-no-swiping');
			});
		}
	});
}
function mouseMove(e, block) {
	let image = block.querySelector('img');
	let blockWidth = block.offsetWidth;
	let blockHeight = block.offsetHeight;
	let imageHeight = image.clientHeight * 3;
	let imageWidth = image.clientWidth * 3;
	let x = e.layerX;
	let y = e.layerY;
	let imageTransformX = -1 * (x / blockWidth) * (imageWidth - blockWidth);
	let imageTransformY = -1 * (y / blockHeight) * (imageHeight - blockHeight);
	if (block.classList.contains('zoomed')) {
		image.setAttribute('style', `transform: translate(${imageTransformX}px,${imageTransformY}px) scale(3)`);
	}
}
function toucheMove(e, block) {
	if (block.classList.contains('zoomed')) {
		e.preventDefault();
		let image = block.querySelector('img');
		let blockWidth = block.offsetWidth;
		let blockHeight = block.offsetHeight;
		let imageHeight = image.clientHeight * 3;
		let imageWidth = image.clientWidth * 3;
		let x = e.touches[0].clientX;
		let y = e.touches[0].clientY;
		let tranclateX = parseInt(new WebKitCSSMatrix(window.getComputedStyle(image).transform).m41);
		let tranclateY = parseInt(new WebKitCSSMatrix(window.getComputedStyle(image).transform).m42);
		let imageTransformX;
		let imageTransformY;
		if (previousX > x) {
			imageTransformX = tranclateX - (previousX - x);
		} else if (previousX < x) {
			imageTransformX = tranclateX + Math.abs(previousX - x);
		}
		if (previousY > y) {
			imageTransformY = tranclateY - (previousY - y);
		} else if (previousY < y) {
			imageTransformY = tranclateY + Math.abs(previousY - y);
		}
		if (imageTransformX >= 0) {
			imageTransformX = 0;
		}
		if (imageTransformX < -1 * (imageWidth - blockWidth)) {
			imageTransformX = -1 * (imageWidth - blockWidth);
		}
		if (imageTransformY > 0) {
			imageTransformY = 0;
		}
		if (imageTransformY < -1 * (imageHeight - blockHeight)) {
			imageTransformY = -1 * (imageHeight - blockHeight);
		}
		if (imageTransformX != null && imageTransformY != null) {
			image.setAttribute('style', `transform: translate(${imageTransformX}px,${imageTransformY}px) scale(3)`);
		}
		previousX = x;
		previousY = y;
	}
}
function starterPosition(e, block) {
	let image = block.querySelector('img');
	let blockWidth = block.offsetWidth;
	let blockHeight = block.offsetHeight;
	let imageHeight = image.clientHeight * 3;
	let imageWidth = image.clientWidth * 3;
	let x = e.layerX;
	let y = e.layerY;
	if (isTouchDevice()) {
		x = e.clientX;
		y = e.clientY;
	}
	let imageTransformX = -1 * (x / blockWidth) * (imageWidth - blockWidth);
	let imageTransformY = -1 * (y / blockHeight) * (imageHeight - blockHeight);
	image.setAttribute('style', `transform: translate(${imageTransformX}px,${imageTransformY}px) scale(3)`);

}
function isTouchDevice() {
	return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
